module.exports = __webpack_public_path__ + "static/media/dvc.b2bc3a2a.jpg";